import { createUseStyles } from 'react-jss';

const styles = createUseStyles(() => ({
  'spinner': {
    'display': 'grid',
    'placeItems': 'center',
    'minHeight': '100vh',
    '& img': {
      width: '32px',
      height: '32px',
      animation: '$rotation 0.8s infinite linear',
    },
  },
  '@keyframes rotation': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
}));

export default styles;
